import { gql } from '@apollo/client';

export const GET_PUSH_CAMPAIGN_RECIPIENT_COUNT = gql`
    query GetPushCampaignRecipientCount($data: EmailTargetingOptionsInput) {
        getPushCampaignRecipientCount(data: $data) {
            count
            breakdown
            emailTargetedCount
            deviceEligibleCount
        }
    }
`;
